export default defineNuxtRouteMiddleware(async (to, from) => {
	// Only run on client side to avoid SSR issues
	if (process.server) return;
	
	const { status } = useAuth();
	const { transferGuestBudgetIfExists, showTransferResult } = useGuestBudgetTransfer();
	
	// Only proceed if user is authenticated
	if (status.value === 'authenticated') {
		const isFromGuestMode = Boolean(localStorage.getItem('isFromGuestMode'));
		const guestBudget = localStorage.getItem('guestBudget');
		
		// Only attempt transfer if we have both the flag and budget data
		if (isFromGuestMode && guestBudget) {
			// Add a small delay to allow the plugin to handle the transfer first
			// This prevents race conditions between plugin and middleware
			setTimeout(async () => {
				// Check again if the flag is still present (plugin might have cleared it)
				if (localStorage.getItem('isFromGuestMode')) {
					try {
						const result = await transferGuestBudgetIfExists();
						
						// Show appropriate message to user
						showTransferResult(result);
						
						// Clear the flag to prevent repeated attempts
						localStorage.removeItem('isFromGuestMode');
						
					} catch (error) {
						console.error('Error in guest budget middleware:', error);
						// Clear the flag even on error to prevent infinite attempts
						localStorage.removeItem('isFromGuestMode');
					}
				}
			}, 500); // 500ms delay to let plugin handle it first
		}
	}
	
	// Allow normal navigation to continue - don't redirect
})